import {
  RECEIVE_SELECTOR_VALS,
  SET_ACTIVE_SELECTOR_VALS,
  REQUEST_APP_INITIALIZER,
} from '../constants/actionTypes';

export const initialState = {
  activeSeasons: [{ id: '', name: '' }],
  list: {},
  sortedSeasonKeys: [],
};

/**
 * Handles redux state for Season Selector and Map Layer Selector data
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function seasonReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACTIVE_SELECTOR_VALS: {
      return {
        ...state,
        activeSeasons: action.activeSeasons,
      };
    }
    case REQUEST_APP_INITIALIZER:
      return {
        ...state,
        activeSeasons: action.seasonIds.length
          ? action.seasonIds.map((season) => ({ id: season }))
          : initialState.activeSeasons,
      };
    case RECEIVE_SELECTOR_VALS: {
      const { seasons, sortedSeasonKeys, activeVals } = action;

      return {
        ...state,
        activeSeasons: activeVals.activeSeasons,
        list: seasons,
        sortedSeasonKeys,
      };
    }
    default: {
      return state;
    }
  }
}

export default seasonReducer;
